// extracted by mini-css-extract-plugin
export var container = "Feedback-module--container--y4P4a";
export var list = "Feedback-module--list--CJ1zs";
export var listItem = "Feedback-module--listItem--inloq";
export var post = "Feedback-module--post--rqViM";
export var star = "Feedback-module--star--N0uKP";
export var starContainer = "Feedback-module--starContainer--LPiW6";
export var subtitle = "Feedback-module--subtitle--JND9r";
export var title = "Feedback-module--title--pM5tN";